module.exports = __webpack_public_path__ + "img/back-icon.0bd140a3.svg";